import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=2384af30&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384af30",
  null
  
)

export default component.exports